export default "__VITE_ASSET__Cpd1xqJ8__"